import { useSelector } from "react-redux";

const RealAutomation = () => {
  let {
    data: { AuthorizationRA },
  } = useSelector((state) => state.Login);
  AuthorizationRA = AuthorizationRA.replace("Bearer ", "");
  window.location.href = `${process.env.REACT_APP_REAL_AUTOMATION_URL}/auth?token=${AuthorizationRA}`;
  return null;
};

export default RealAutomation;
